export default "__VITE_ASSET__CGbQLd1o__"